// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".land-layout-container[data-v-561e699c]{background:#f5f5f5}.land-layout-container .land-layout-content[data-v-561e699c]{width:1200px;margin:20px auto 80px;position:relative}.land-layout-container .product-buy-slot[data-v-561e699c]{width:930px;height:501px;background:#fff;margin-bottom:16px}.land-layout-container .product-intro-slot[data-v-561e699c]{width:930px;height:501px;background:#fff}", ""]);
// Exports
module.exports = exports;
